import styled from "@emotion/styled";


export const SortContainer = styled.div<{open:boolean}>`
    display: ${props => props.open?"flex":"none"};
    position: absolute;
    flex-direction: column;
    align-items: flex-end;
    top:88%;
    left:0;
    width:100%;
    background:#1f6a72;
    padding: 8px 0 8px 0;
    border-radius: 0 0 16px 16px;
  

    span{
        width:100%;
        text-align: right;
        padding:4px 30px 4px 10px;
        :hover{
            background:#027885;
        }
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }
`;


export const SortWrapper = styled.div<{open:boolean, course?:boolean, counselor?:boolean}>`
    height:65%;
    background: ${props => props.open?"#1f6a72":"#2A848E"};
    position: relative;
    margin-left: ${props => props.counselor?"50px":"auto"};
    display: flex;
    align-items: center;
    justify-content: end;
    font-size: 16px;
    color:#fff;
    padding:0 14px;
    border-radius: ${props => props.open?"16px 16px 0 0":"16px"};
    min-width: ${props => props.course?"157px":"80px"};
    cursor:pointer;
    z-index: 41;
    transition: background 0.2s ease-in-out;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
    svg{
        width:16px;
        margin-left: 10px;
        path{
            fill:#fff;
        }
    }

    :hover{
        background:#1f6a72;
    }
`;


